var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTvProgramsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.828,
    height: 20.569,
    viewBox: "0 0 21.828 20.569",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x33_8_x2C__watch_tv_x2C__journalist_x2C__news_x2C__tv_monitor_x2C__television_x2C__tv",
    transform: "translate(-1 -15.713)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21215",
    "data-name": "Group 21215",
    transform: "translate(1 15.713)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21214",
    "data-name": "Group 21214",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21213",
    "data-name": "Group 21213"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21212",
    "data-name": "Group 21212"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42725",
    "data-name": "Path 42725",
    d: "M20.688,20.018H13.182l4.641-3.536A.428.428,0,1,0,17.3,15.8l-5.39,4.107-3.673-2.8a.428.428,0,0,0-.519.681l2.924,2.228H3.14A2.142,2.142,0,0,0,1,22.158V32.387a2.144,2.144,0,0,0,1.712,2.1v1.37a.428.428,0,0,0,.428.428H4.852a.428.428,0,0,0,.4-.281l.539-1.474H18.035L18.574,36a.428.428,0,0,0,.4.281h1.712a.428.428,0,0,0,.428-.428v-1.37a2.144,2.144,0,0,0,1.712-2.1V22.158a2.142,2.142,0,0,0-2.14-2.14ZM4.553,35.426H3.568v-.9H4.882Zm15.707,0h-.985l-.329-.9H20.26Zm1.712-3.039a1.285,1.285,0,0,1-1.284,1.284H3.14a1.285,1.285,0,0,1-1.284-1.284V22.158A1.285,1.285,0,0,1,3.14,20.874H20.688a1.285,1.285,0,0,1,1.284,1.284Z",
    transform: "translate(-1 -15.713)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42726",
    "data-name": "Path 42726",
    d: "M412.284,155.286a1.284,1.284,0,1,0,1.284,1.284A1.285,1.285,0,0,0,412.284,155.286Zm0,1.712a.428.428,0,1,1,.428-.428A.428.428,0,0,1,412.284,157Z",
    transform: "translate(-393.452 -149.312)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42727",
    "data-name": "Path 42727",
    d: "M412.284,235.286a1.284,1.284,0,1,0,1.284,1.284A1.285,1.285,0,0,0,412.284,235.286Zm0,1.712a.428.428,0,1,1,.428-.428A.428.428,0,0,1,412.284,237Z",
    transform: "translate(-393.452 -225.888)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42728",
    "data-name": "Path 42728",
    d: "M413.14,315.286h-1.712a.428.428,0,0,0,0,.856h1.712a.428.428,0,1,0,0-.856Z",
    transform: "translate(-393.452 -302.464)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42729",
    "data-name": "Path 42729",
    d: "M413.14,355.286h-1.712a.428.428,0,0,0,0,.856h1.712a.428.428,0,1,0,0-.856Z",
    transform: "translate(-393.452 -340.752)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42730",
    "data-name": "Path 42730",
    d: "M413.14,395.286h-1.712a.428.428,0,0,0,0,.856h1.712a.428.428,0,1,0,0-.856Z",
    transform: "translate(-393.452 -379.04)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42731",
    "data-name": "Path 42731",
    d: "M55.552,155.286H41.428a.428.428,0,0,0-.428.428v10.272a.428.428,0,0,0,.428.428H55.552a.428.428,0,0,0,.428-.428V155.714A.428.428,0,0,0,55.552,155.286Zm-.428,10.272H41.856v-9.416H55.124Z",
    transform: "translate(-39.288 -149.312)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42732",
    "data-name": "Path 42732",
    d: "M166.091,234.86l2.52-1.417a.936.936,0,0,0,0-1.632l-2.52-1.417a.936.936,0,0,0-1.395.816v2.835A.936.936,0,0,0,166.091,234.86Zm-.539-3.65a.08.08,0,0,1,.119-.07l2.52,1.417a.08.08,0,0,1,0,.139l-2.52,1.417a.08.08,0,0,1-.119-.07Z",
    transform: "translate(-157.69 -221.089)",
    fill: "#fff"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvProgramsIcon);
export default __webpack_public_path__ + "static/media/tvProgramsIcon.2e8cf69a794cd854d655ada8df11feaa.svg";
export { ForwardRef as ReactComponent };